import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
export const OfferSection: React.FC = () => {
  const handleBuyClick = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  const offerItems = [{
    name: 'Guía "Oro en la Calle" (8 capítulos)',
    value: CONSTANTS.PRICES.ITEMS.MAIN
  }, {
    name: 'Cap. 1-2: Quilates + 6 Pruebas de Autenticidad',
    value: CONSTANTS.PRICES.ITEMS.CAP_1_2
  }, {
    name: 'Cap. 3: La Balanza + Regla del 70-80%',
    value: CONSTANTS.PRICES.ITEMS.CAP_3
  }, {
    name: 'Cap. 4-5: Operatoria Callejera + Dónde Vender',
    value: CONSTANTS.PRICES.ITEMS.CAP_4_5
  }, {
    name: 'Cap. 6-8: Zonas Clave + Escalar + Herramientas',
    value: CONSTANTS.PRICES.ITEMS.CAP_6_8
  }, {
    name: '🎁 BONO: Mapa Real de Compra/Venta',
    value: CONSTANTS.PRICES.ITEMS.BONO_1,
    isBonus: true
  }, {
    name: '🎁 BONO: Vender Oro con Instagram y TikTok',
    value: CONSTANTS.PRICES.ITEMS.BONO_2,
    isBonus: true
  }, {
    name: '🎁 BONO: Calculadora de Valor del Oro (Excel)',
    value: CONSTANTS.PRICES.ITEMS.BONO_3,
    isBonus: true
  }];
  return <section id="oferta" className="py-20 scroll-mt-20 relative" style={{
    background: 'radial-gradient(ellipse at 50% 50%, rgba(200,163,78,0.06) 0%, transparent 70%)'
  }} data-id="element-101">
      <div className="container mx-auto px-4 max-w-2xl" data-id="element-102">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-103">
          Todo lo que vas a{' '}
          <span style={{
          color: 'var(--gold)'
        }} data-id="element-104">
            recibir hoy
          </span>
        </h2>

        <div className="rounded-2xl p-10 relative" style={{
        background: 'var(--bg-card)',
        border: '2px solid var(--border-gold)',
        boxShadow: 'var(--shadow-gold)'
      }} data-id="element-105">
          <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 px-6 py-1.5 rounded-full text-xs font-extrabold tracking-widest uppercase" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)'
        }} data-id="element-106">
            MEJOR OFERTA
          </div>

          <div className="space-y-2.5 mb-4" data-id="element-107">
            {offerItems.map((item, index) => <div key={index} className="flex justify-between py-2.5 text-sm" style={{
            borderBottom: '1px solid var(--border-subtle)',
            color: 'var(--text-secondary)'
          }} data-id="element-108">
                <span data-id="element-109">{item.name}</span>
                <span className="line-through" style={{
              color: 'var(--text-muted)'
            }} data-id="element-110">
                  $ {item.value} ARS
                </span>
              </div>)}
          </div>

          <div className="flex justify-between py-4 font-bold border-t" style={{
          borderTopColor: 'var(--border-gold)',
          color: 'var(--text-secondary)'
        }} data-id="element-111">
            <span data-id="element-112">Valor total:</span>
            <span className="line-through" style={{
            color: 'var(--text-muted)'
          }} data-id="element-113">
              $ {CONSTANTS.PRICES.ITEMS.TOTAL_VALUE} ARS
            </span>
          </div>

          <div className="text-center mt-8" data-id="element-114">
            <p className="text-sm mb-2" style={{
            color: 'var(--text-muted)'
          }} data-id="element-115">
              🇦🇷 Precio en tu moneda · Hoy lo llevás por:
            </p>
            <div className="mb-1" data-id="element-116">
              <span className="text-2xl line-through mr-3" style={{
              color: 'var(--text-muted)'
            }} data-id="element-117">
                $ {CONSTANTS.PRICES.ORIGINAL}
              </span>
              <span className="font-serif text-5xl md:text-6xl font-black" style={{
              color: 'var(--gold)'
            }} data-id="element-118">
                $ {CONSTANTS.PRICES.SALE}
              </span>
              <span className="text-lg ml-2" style={{
              color: 'var(--text-muted)'
            }} data-id="element-119">
                ARS
              </span>
              <span className="inline-block px-3.5 py-1 rounded text-xs font-extrabold ml-3 align-super" style={{
              background: 'var(--red-alert)',
              color: 'white'
            }} data-id="element-120">
                {CONSTANTS.PRICES.DISCOUNT}
              </span>
            </div>
            <p className="text-xs mt-1" style={{
            color: 'var(--text-muted)'
          }} data-id="element-121">
              Precio aproximado en ARS · El cobro final se realiza en USD
            </p>
          </div>

          <div className="text-center mt-5 text-sm font-semibold" style={{
          color: 'var(--accent-warm)'
        }} data-id="element-122">
            🔥 Precio de lanzamiento por tiempo limitado
          </div>

          <button onClick={handleBuyClick} className="w-full font-bold text-xl px-8 py-5 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 mt-7" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)',
          boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
        }} data-id="element-123">
            SÍ, QUIERO ACCEDER AHORA
          </button>

          <p className="text-center text-xs mt-3" style={{
          color: 'var(--text-muted)'
        }} data-id="element-124">
            Pago único · Sin suscripción · Acceso de por vida
          </p>

          <div className="flex flex-wrap justify-center gap-6 mt-5 text-xs" style={{
          color: 'var(--text-muted)'
        }} data-id="element-125">
            <span data-id="element-126">🔒 Pago 100% Seguro</span>
            <span data-id="element-127">⚡ Entrega Inmediata</span>
            <span data-id="element-128">✓ Garantía 7 Días</span>
          </div>

          <div className="text-center text-xs mt-4 leading-relaxed" style={{
          color: 'var(--text-muted)'
        }} data-id="element-129">
            Visa · Mastercard · Amex · PayPal · Compra protegida · Procesado por
            Hotmart · Encriptación SSL
          </div>
        </div>
      </div>
    </section>;
};